import { connect } from 'react-redux';

import { getDataTypes } from '../store/actions/dataTypes';
import DataTypesComponent from '../components/developerApi/developerSdk/DataTypes/DataTypesComponent';

const mapStateToProps = ({ session: { user }, dataTypes: { isLoading, items } }) => ({
    isLoading,
    namespaces: items,
    user,
});

const mapDispatchToProps = {
    getDataTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(DataTypesComponent);



// WEBPACK FOOTER //
// ./src/containers/DataTypesContainer.js